
import { Helmet } from "react-helmet";
import Products from "../../components/products/products";

export default function ViewAllTopSelling() {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | Top Selling - Most Popular Products</title>
                <meta
                    name="description"
                    content="Browse SHOP.CO’s top selling products. Discover what everyone is buying and find the most popular items loved by our customers."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/view-all-topSelling/"
                />
            </Helmet>

            <Products endPoint="topSelling-products" />
        </>
    )
}